export async function getDataStaffBonus(params: string) {
  if (params) {
    try {
      const response = await fetch(
        `/internal-api/employee/statistics/report/positions/bonus?${params}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
